<template>
  <div
    id="title-bar"
    class="flex w-full justify-between items-center"
  >
    <div class="logo-title w-1/2">
      <ul
        class="
          w-full
          flex
          justify-start
          flex-wrap
          items-center
          col-gap-12
          aisea-text-12-400-black
          h-12
        "
      >
        <li class="title-logo">
          <logo-horizontal />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LogoHorizontal from "./LogoHorizontal.vue";


export default {
  name: "TitleBarArea",
  mixins: [],
  components: {
    LogoHorizontal,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss">
#title-bar {
  padding-left: 24px;
  padding-top: 20px;
}
</style>
